module.exports = __webpack_public_path__ + "img/app-3.d4da7fa1.png";